import { render, staticRenderFns } from "./global_alerts.vue.js?vue&type=template&id=76fe3914!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./global_alerts.vue?vue&type=template&id=76fe3914"
import script from "./global_alerts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./global_alerts.vue?vue&type=script&lang=js"
export * from "./global_alerts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./global_alerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76fe3914')) {
      api.createRecord('76fe3914', component.options)
    } else {
      api.reload('76fe3914', component.options)
    }
    module.hot.accept("./global_alerts.vue.js?vue&type=template&id=76fe3914!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./global_alerts.vue?vue&type=template&id=76fe3914", function () {
      api.rerender('76fe3914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "behaviors/components/global_alerts.vue"
export default component.exports